export default __webpack_public_path__ + "static/media/PowerCost.a0445aeb.svg";